<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="title">主体资料</div>
      <div>
        <SubjectType :subjectData="subjectData"></SubjectType>
        <Registration :subjectData="subjectData"></Registration>
        <Organization :subjectData="subjectData"></Organization>
        <IdCard :subjectData="subjectData"></IdCard>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="next">下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SubjectType from '../../components/details/subjectDetails/subjectType';
import Registration from '../../components/details/subjectDetails/registration';
import Organization from '../../components/details/subjectDetails/organization';
import IdCard from '../../components/details/subjectDetails/idCard';
import { draftEcho } from '../../../../api/module/merchants';
export default {
  components: {
    SubjectType,
    Registration,
    Organization,
    IdCard,
  },
  props: {},
  data() {
    return {
      subjectData: {},
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
  },
  watch: {},
  created() {
    this.draftEcho();
  },
  methods: {
    back() {
      this.$router.push({
        path: '/merchants',
      });
    },
    next() {
      const { uuid } = this;
      this.$router.push({
        path: '/merchants/settlementDetails',
        query: {
          uuid,
        },
      });
    },
    async draftEcho() {
      const { uuid } = this;
      const result = await draftEcho({
        uuid,
      });
      this.subjectData = result.subjectDataVO;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  .title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .marRight {
    margin-right: 38px;
  }
  .btn {
    margin-top: 20px;
  }
}
</style>
